import React from 'react';

const SettingsSaveButton = React.memo(({
  onClick,
  isSaving = false,
  label = 'Kaydet',
  savingLabel = 'Kaydediliyor...',
  variant = 'default',
  className = ''
}) => {
  return (
    <button
      type="button"
      className={`settings-save-btn ${variant === 'compact' ? 'settings-save-btn--compact' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={isSaving}
    >
      {isSaving ? (
        <>
          <i className="fas fa-spinner fa-spin" aria-hidden="true"></i>
          <span>{savingLabel}</span>
        </>
      ) : (
        <>
          <i className="fas fa-check" aria-hidden="true"></i>
          <span>{label}</span>
        </>
      )}
    </button>
  );
});

export default SettingsSaveButton;
